"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  data: function data() {
    return {
      itemInfo: {},
      activeSetting: 1,
      deleteConfirmVisible: false
    };
  },
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {
          buttonText: '确认兑换',
          textPosition: 1,
          // 1=居左, 2=居中, 3=居右
          themeColor: '#FFFFFF',
          buttonWidth: 120,
          buttonHeight: 44,
          cornerType: 1,
          // 1=统一设置, 2=分开设置
          borderRadius: 4,
          borderRadiusTopLeft: 4,
          borderRadiusTopRight: 4,
          borderRadiusBottomRight: 4,
          borderRadiusBottomLeft: 4,
          bgImg: '',
          bgPic: '',
          bgColor: '#1989fa',
          marginType: 1,
          // 1=统一设置, 2=分开设置
          margin: 0,
          marginTop: 0,
          marginRight: 0,
          marginBottom: 0,
          marginLeft: 0
        };
      }
    }
  },
  watch: {
    value: {
      handler: function handler() {
        var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // 确保默认值的存在
        this.itemInfo = _objectSpread({
          buttonText: '确认兑换',
          textPosition: 1,
          themeColor: '#FFFFFF',
          buttonWidth: 120,
          buttonHeight: 44,
          cornerType: 1,
          borderRadius: 4,
          borderRadiusTopLeft: 4,
          borderRadiusTopRight: 4,
          borderRadiusBottomRight: 4,
          borderRadiusBottomLeft: 4,
          bgImg: '',
          bgPic: '',
          bgColor: '#1989fa',
          marginType: 1,
          margin: 0,
          marginTop: 0,
          marginRight: 0,
          marginBottom: 0,
          marginLeft: 0
        }, val);
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    updateItem: function updateItem() {
      this.$emit("input", this.itemInfo);
    },
    increaseValue: function increaseValue(field) {
      if (!this.itemInfo[field] && this.itemInfo[field] !== 0) {
        this.itemInfo[field] = 0;
      }
      this.itemInfo[field]++;
      this.updateItem();
    },
    decreaseValue: function decreaseValue(field) {
      if (!this.itemInfo[field] && this.itemInfo[field] !== 0) {
        this.itemInfo[field] = 0;
      }
      if (field === 'buttonWidth' && this.itemInfo[field] > 60) {
        this.itemInfo[field]--;
      } else if (field === 'buttonHeight' && this.itemInfo[field] > 30) {
        this.itemInfo[field]--;
      } else if ((field === 'borderRadius' || field === 'borderRadiusTopLeft' || field === 'borderRadiusTopRight' || field === 'borderRadiusBottomRight' || field === 'borderRadiusBottomLeft') && this.itemInfo[field] > 0) {
        this.itemInfo[field]--;
      } else if ((field === 'margin' || field === 'marginTop' || field === 'marginRight' || field === 'marginBottom' || field === 'marginLeft') && this.itemInfo[field] > 0) {
        this.itemInfo[field]--;
      }
      this.updateItem();
    },
    modalPicTap: function modalPicTap(tit, type) {
      var _this = this;
      this.$modalUpload(function (img) {
        if (type === 'bgImg' || type === 'bgPic') {
          _this.$set(_this.itemInfo, type, img[0].sattDir);
        }
        _this.updateItem();
      }, tit, 'system');
    }
  }
};